import LoadingComponent from '@/components/common/LoadingComponent';
import { LastActivitiesStatusAndActionProps } from '@/types/props/components';
import { toDe } from '@/utilites/sku-operations';
import translationFallback from '@/utilites/translations/translationFallback';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

export default function LastActivitiesStatusAndActionMobile({
  status,
  tCommon,
}: LastActivitiesStatusAndActionProps) {
  const basicClass =
    'tw-p-2 tw-rounded-lg tw-font-bold tw-w-32 tw-flex tw-flex-col tw-items-center tw-justify-center tw-aspect-[2/1]';

  const currentStatus = {
    action: 'Bid',
    class: basicClass + ' ' + 'tw-bg-[#e7f4ef] tw-text-green-700',
  };

  if (status === null) {
    return (
      <LoadingComponent
        as="div"
        componentProps={{
          className: 'tw-contents',
        }}
        loading={true}
      >
        <div className="tw-flex tw-aspect-[2/1] tw-w-32 tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#E7E9EB] tw-p-2 tw-font-bold tw-text-gray-600"></div>
      </LoadingComponent>
    );
  }
  if (status.asks) {
    currentStatus.action = 'Ask';
    currentStatus.class = basicClass + ' ' + 'tw-bg-[#E7E9EB] tw-text-gray-600';
  } else if (status.orders) {
    currentStatus.action = 'Order';
    currentStatus.class = basicClass + ' ' + 'tw-bg-[#F3EFE5] tw-text-yellow-800';
  }
  let price = 0;
  if (status.asks && status.asks[0]) {
    price = status.asks[0].value;
  } else if (status.bids && status.bids[0]) {
    price = status.bids[0].value;
  } else if (status.orders && status.orders[0]) {
    price = status.orders[0].payValue;
  }
  return (
    <div className={twMerge(currentStatus.class, '!tw-h-16 !tw-w-auto tw-max-w-[74px]')}>
      <span className="tw-text-xs-custom tw-font-semibold tw-leading-[16.38px]">
        {translationFallback(
          currentStatus.action.toLowerCase(),
          tCommon(currentStatus.action.toLowerCase()),
          currentStatus.action
        )}
      </span>
      <strong
        className={clsx('tw-text-base tw-font-semibold', {
          'tw-text-[#0B613C]': currentStatus.action === 'Bid',
          'tw-text-[#15253F]': currentStatus.action === 'Ask',
          'tw-text-[#857040]': currentStatus.action === 'Order',
        })}
      >
        {toDe(price).replace(' ', '')}
      </strong>
    </div>
  );
}
